import React, { FC } from 'react';

import { extractHighlightedWordsFromString } from './extractHighlightedWordsFromString';

type Props = {
  children: string | number;
  config?: { preTag: string; postTag: string };
  renderHighlightedParts: (
    item: { highlighted: boolean; value: string },
    index: number,
  ) => React.ReactNode;
};

export const RenderHighlightedParts: FC<Props> = ({
  children,
  config,
  renderHighlightedParts,
}) => {
  const suggestion = extractHighlightedWordsFromString(children, config);

  return <>{suggestion.map(renderHighlightedParts)}</>;
};
